import { createAction } from '@reduxjs/toolkit';
import { Map as ImMap, RecordOf } from 'immutable';
import { RootUiData } from './rootUiTypes';

export const createDialog = createAction<RecordOf<RootUiData>>('CREATE_DIALOG');
export const removeDialog = createAction('REMOVE_DIALOG', (dialogId?: string | 0, meta?: { animate?: boolean }) => ({
  payload: dialogId,
  meta,
}));
export const showNextDialog = createAction('SHOW_NEXT_DIALOG');
export const updateDialogProps = createAction<{ id: string; props: ImMap<string, any> }>('UPDATE_DIALOG_PROPS');
